export const STORE_STATES = "importExport/STORE_STATES";
export const STORE_CITIES = "importExport/STORE_CITIES";
export const STORE_UNITS = "importExport/STORE_UNITS";
export const STORE_ACCESSORIES = "importExport/STORE_ACCESSORIES";
export const STORE_CESS = "importExport/STORE_CESS";
export const STORE_CESS_GENERAL_DUTY = "importExport/STORE_CESS_GENERAL_DUTY";
export const STORE_CONTAINER_SEAL_TYPES = "importExport/STORE_CONTAINER_SEAL_TYPES";
export const STORE_CONTAINER_SIZES = "importExport/STORE_CONTAINER_SIZES";
export const STORE_CONTAINER_TYPES = "importExport/STORE_CONTAINER_TYPES";
export const STORE_COUNTRIES = "importExport/STORE_COUNTRIES";
export const STORE_DISTRICT_CODES = "importExport/STORE_DISTRICT_CODES";
export const STORE_DOCUMENT_TYPE_CODES = "importExport/STORE_DOCUMENT_TYPE_CODES";
export const STORE_CURRENCIES = "importExport/STORE_CURRENCIES";
export const STORE_DECLARATIONS = "importExport/STORE_DECLARATIONS";
export const STORE_RODTEPS = "importExport/STORE_RODTEPS";
export const STORE_END_USES = "importExport/STORE_END_USES";
export const STORE_EXPORTER_TYPES = "importExport/STORE_EXPORTER_TYPES";
export const STORE_EXPORT_UNDERS = "importExport/STORE_EXPORT_UNDERS";
export const STORE_GOODS_STUFFED_AT = "importExport/STORE_GOODS_STUFFED_AT";
export const STORE_GST_IN_TYPES = "importExport/STORE_GST_IN_TYPES";
export const STORE_IGST_PAYMENT_STATUS = "importExport/STORE_IGST_PAYMENT_STATUS";
export const STORE_NATURE_OF_CARGO = "importExport/STORE_NATURE_OF_CARGO";
export const STORE_SEAL_TYPES = "importExport/STORE_SEAL_TYPES";
export const STORE_SHIPMENT_TYPES = "importExport/STORE_SHIPMENT_TYPES";
export const STORE_SHOW_FOB_INS = "importExport/STORE_SHOW_FOB_INS";
export const STORE_SHOW_NATURE_OF_PAYMENTS = "importExport/STORE_SHOW_NATURE_OF_PAYMENTS";
export const STORE_TERMS_OF_INVOICES = "importExport/STORE_TERMS_OF_INVOICES";
export const STORE_UNIT_PRICE_INCLUDES = "importExport/STORE_UNIT_PRICE_INCLUDES";
export const STORE_RITC_CODES = "importExport/STORE_RITC_CODES";
export const STORE_EXIM_SCHEME_CODES = "importExport/STORE_EXIM_SCHEME_CODES";
export const STORE_FOREIGN_PORTS = "importExport/STORE_FOREIGN_PORTS";
export const STORE_HOME_PORTS = "importExport/STORE_HOME_PORTS";
export const STORE_PTA_FTAS = "importExport/STORE_PTA_FTAS";
export const STORE_DRAW_BACK_RATES = "importExport/STORE_DRAW_BACK_RATES";
export const ADD_ESANCHIT_SUPPORTING_DOC = "supportingDoc/ADD_ESANCHIT_SUPPORTING_DOC";
export const UPDATE_ESANCHIT_SUPPORTING_DOC = "supportingDoc/UPDATE_ESANCHIT_SUPPORTING_DOC";
export const GET_ESANCHIT_SUPPORTING_DOC = "supportingDoc/GET_ESANCHIT_SUPPORTING_DOC";
export const DELETE_ESANCHIT_SUPPORTING_DOC = "supportingDoc/DELETE_ESANCHIT_SUPPORTING_DOC";
